"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));

var _reactI18next = require("react-i18next");

var _styleModule = _interopRequireDefault(require("./style.module.scss"));

var _jsxRuntime = require("react/jsx-runtime");

var EditSubtitle = function EditSubtitle(_ref) {
  var index = _ref.index,
      item = _ref.item;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [index > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Divider.default, {
      className: _styleModule.default.divider
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
        variant: "h4",
        component: "h4",
        align: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: _styleModule.default.subtitle,
          children: item.key ? t(item.translations.headline) : ''
        })
      }), item.translations.description && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: _styleModule.default.description,
        children: item.key ? t(item.translations.description) : ''
      })]
    }, item.key)]
  });
};

var _default = EditSubtitle;
exports.default = _default;